import { useFormContext } from "react-hook-form"

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "~/v2/components/ui/card"
import FormField from "~/v2/components/vaas/form-field"
import VaasThumbnailField from "~/v2/components/vaas/vaas-thumbnail-field"
import type { VaasEditValues, VaasThumbnail } from "~/v2/types/vaas"

type VaasCourseSectionProps = {
  isPublished?: boolean
  onThumbnailUploaded?: (thumbnail: VaasThumbnail) => Promise<void> | void
}

const VaasCourseSection = ({
  isPublished = false,
  onThumbnailUploaded,
}: VaasCourseSectionProps) => {
  const { register } = useFormContext<VaasEditValues>()

  return (
    <Card>
      <CardHeader>
        <CardTitle>VAAS course details</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4 md:grid-cols-2">
        <FormField label="Course name" name="course_name" />
        <div className="md:col-span-2">
          <FormField
            description="Optional redirect URL for VAAS logo."
            label="VAAS logo redirect"
            name="vaas_logo_redirect"
          />
        </div>
        <label className="flex items-start gap-3 rounded-md border border-border bg-muted/20 p-4 md:col-span-2">
          <input
            {...register("vaas_show_feedback")}
            className="mt-1"
            type="checkbox"
          />
          <span className="flex flex-col gap-1">
            <span className="text-sm font-medium text-foreground">
              Show feedback
            </span>
            <span className="text-xs text-muted-foreground">
              Allow VAAS learners to submit feedback in the app.
            </span>
          </span>
        </label>
        <VaasThumbnailField
          disabled={isPublished}
          onUploaded={onThumbnailUploaded}
        />
      </CardContent>
    </Card>
  )
}

export default VaasCourseSection
